/**
 * TableSkeleton - Skeleton loader za tabele
 * Prikazuje animirane skeleton redove koji odgovaraju strukturi tabele
 */

import React from 'react';
import { Skeleton, Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import './skeletons.css';

interface TableSkeletonProps {
  /** Broj skeleton redova za prikaz */
  rows?: number;
  /** Broj skeleton kolona za prikaz */
  columns?: number;
  /** Da li prikazati checkbox kolonu (za selektabilne tabele) */
  showCheckbox?: boolean;
}

export const TableSkeleton: React.FC<TableSkeletonProps> = ({
  rows = 10,
  columns = 5,
  showCheckbox = false,
}) => {
  // Generisanje skeleton kolona
  const skeletonColumns: ColumnsType<any> = Array.from(
    { length: columns },
    (_, index) => ({
      key: `skeleton-col-${index}`,
      dataIndex: `col${index}`,
      title: <Skeleton.Input active size="small" style={{ width: 100 }} />,
      render: () => (
        <Skeleton.Input
          active
          size="small"
          style={{
            width: index === 0 ? '80%' : '60%',
            minWidth: index === 0 ? 150 : 80,
          }}
        />
      ),
      width: index === 0 ? 200 : undefined, // Prva kolona šira (obično naslov/ime)
    })
  );

  // Generisanje skeleton podataka
  const skeletonData = Array.from({ length: rows }, (_, index) => ({
    key: `skeleton-row-${index}`,
    id: `skeleton-${index}`,
  }));

  return (
    <>
      <span className="sr-only" role="status" aria-live="polite">
        Učitavanje podataka...
      </span>
      <Table
        className="table-skeleton"
        columns={skeletonColumns}
        dataSource={skeletonData}
        pagination={false}
        rowSelection={showCheckbox ? { selectedRowKeys: [] } : undefined}
        showHeader={true}
      />
    </>
  );
};
